import React from "react";
import { Tabs } from "antd";

const ButtonAlignment = ({
    activeTab,
    setActiveTab,
    onTabChange,
    hideHolidays = false
}) => {

    return (
        <div className="w-full flex justify-center mt-6 px-4">

            <div className="bg-white border border-gray-300 rounded-xl p-2 mb-[20px] inline-block">
                <Tabs
                    className="
                        [&_.ant-tabs-nav]:m-0
                        [&_.ant-tabs-nav::before]:hidden
                        [&_.ant-tabs-tab]:p-0
                        [&_.ant-tabs-tab]:mx-1
                        [&_.ant-tabs-tab]:min-h-0
                        [&_.ant-tabs-tab]:cursor-pointer
                        [&_.ant-tabs-tab-btn]:cursor-pointer
                    "
                    tabBarGutter={12}
                    activeKey={activeTab}
                    onChange={(key) => {
                        setActiveTab(key);
                        if (onTabChange) {
                            onTabChange(key);
                        }
                    }}
                    items={[
                        {
                            key: "masters-configuration",
                            label: (
                                <div
                                    className={`px-4 py-1 rounded-md text-xs sm:text-sm leading-none whitespace-nowrap transition-all duration-200 ${activeTab === "masters-configuration"
                                            ? "bg-red-50 text-red-600"
                                            : "text-gray-500"
                                        }`}
                                >
                                    Role Configuration
                                </div>
                            ),
                        },

                        {
                            key: "user-management",
                            label: (
                                <div
                                    className={`px-4 py-1 rounded-lg text-xs sm:text-sm leading-none whitespace-nowrap transition-all duration-200 ${activeTab === "user-management"
                                            ? "bg-red-50 text-red-600"
                                            : "text-gray-500"
                                        }`}
                                >
                                    User Management
                                </div>
                            ),
                        },

                        {
                            key: "attendance-daily-norm",
                            label: (
                                <div
                                    className={`px-4 py-1 rounded-lg text-xs sm:text-sm leading-none whitespace-nowrap transition-all duration-200 ${activeTab === "attendance-daily-norm"
                                            ? "bg-red-50 text-red-600"
                                            : "text-gray-500"
                                        }`}
                                >
                                    Attendance Required
                                </div>
                            ),
                        },

                        {
                            key: "holidays",
                            // label: (
                                // <div
                                //     className={`px-4 py-1 rounded-lg text-xs sm:text-sm leading-none whitespace-nowrap transition-all duration-200 ${activeTab === "holidays"
                                //             ? "bg-red-50 text-red-600"
                                //             : "text-gray-500"
                                //         }`}
                                // >
                                //     Mark Holidays
                                // </div>
                            // ),
                        },
                    ]}
                />

            </div>

        </div>
    );
};

export default ButtonAlignment;